export default __webpack_public_path__ + "static/FS2S-InHub-88-96ad233c855b92b7146328b952c64799.jpg";